// covered-by: frontends/carrie/src/ask-v2/home/__tests__/homeCopy.test.ts
/**
 * Pure helpers behind the personalized home copy: the client clock christo
 * receives, and the split that paints one headline word in the brand blue.
 */
import {
  splitHeadlineOnAccent,
  type HeadlineAccentSplit,
} from "@mg/schemas/src/christo/askPunttHomeCopy";

export { splitHeadlineOnAccent };
export type HeadlineSplit = HeadlineAccentSplit;

function pad2(value: number): string {
  return value < 10 ? `0${value}` : String(value);
}

/** Wall-clock time in the browser's zone, `YYYY-MM-DDTHH:mm`, no offset. */
export function clientLocalDateTime(now: Date = new Date()): string {
  return (
    `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}` +
    `T${pad2(now.getHours())}:${pad2(now.getMinutes())}`
  );
}

/** IANA zone name from the browser; "UTC" when the runtime cannot say. */
export function clientTimezone(): string {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return zone && zone.trim() ? zone : "UTC";
  } catch {
    return "UTC";
  }
}

/** The calendar day of a client clock string, for the query key. */
export function localDateKey(localDateTime: string): string {
  return localDateTime.slice(0, 10);
}

/**
 * Split a headline around the first whole word "Puntt" so the default hero
 * can keep the gradient accent on the brand name. Null when the word is absent.
 */
export function splitHeadlineOnPuntt(headline: string): HeadlineSplit | null {
  return splitHeadlineOnAccent(headline, "Puntt");
}
